import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Main = withSafeSuspense(lazy(
  async () => ({ default: (await import('./main')).Main })
))
